import {conf} from '@convincely/utils/lib/services/conf.js';
import {getContent} from '../components/InputText/input-text.js';
import {inputs} from '@convincely/components/src/components/Item/InputItem.js';
import {get} from '@convincely/components/src/library.js';
import {inputMap} from '../components/Customiser/store.js';

export function getEndpoint(obj, fallback) {
  if (!obj) {
    return fallback;
  }

  if (typeof obj === 'string') {
    return obj;
  }

  if (obj.label) {
    return obj.label;
  }

  if (conf.isLocal) {
    return obj.local || obj.dev;
  }

  if (conf.isUAT) {
    return obj.uat;
  }

  if (conf.isDev) {
    return obj.dev;
  }

  if (obj.prod) {
    return obj.prod;
  }

  return fallback;
}

export function getDynamicEndpoint(obj, fallback) {
  const endpoint = getEndpoint(obj, fallback);

  return getContent(get(inputs), endpoint, get(inputMap));
}
